/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ClassificationSource = {
    OperatorManual: 'OperatorManual',
    WebshopSso: 'WebshopSso',
    Import: 'Import',
    HrFeed: 'HrFeed'
} as const;
export type ClassificationSource = typeof ClassificationSource[keyof typeof ClassificationSource];

